<script>
import DatePicker from '../DatePicker/DatePicker.vue';
import DropdownMenu from '../DropdownMenu/DropdownMenu.vue';
import {mapActions, mapState, mapGetters} from 'vuex';
import Fake from '../Fake/Fake.vue';

export default {
    components: {
        DatePicker,
        DropdownMenu,
        Fake
    },
    computed: {
        ...mapState({
            suppliers: state => state.booking.bookings.filters.suppliers,
            brands: state => state.booking.bookings.filters.brands,
            domains: state => state.booking.bookings.filters.domains,
            countries: state => state.booking.bookings.filters.countries,
            sites: state => state.booking.bookings.filters.sites,
            accommodations: state => state.booking.bookings.filters.accommodations,
            status: state => state.booking.bookings.filters.status,
            loading: state => state.booking.bookings.filters.loading,
            error: state => state.booking.bookings.filters.error,
            selected: state => state.booking.bookings.filters.selected,
            season: state => state.booking.bookings.filters.season,
            user: state => state.auth.user,
            supplier: state => state.auth.supplier
        }),
        ...mapGetters({
            siteNames: 'booking/siteNames',
            allDomains: 'booking/allDomains',
            allAccommodations: 'booking/allAccommodations'
        }),
        bookingPeriod: {
            get () {
                return this.$store.state.booking.bookings.filters.bookingPeriod
            },
            set (value) {
                this.setBookingPeriod(value).then(() => {
                    this.setArrivalPeriod(this.season).then(() => {
                        this.getBookings(this.supplier.id);
                    })
                });
            }
        },
        arrivalPeriod: {
            get () {
                return this.$store.state.booking.bookings.filters.arrivalPeriod
            },
            set (value) {
                this.setArrivalPeriod(value).then(() => {
                    this.getBookings(this.supplier.id);
                });
            }
        }
    },
    methods: {
        ...mapActions({
            setBookingPeriod: 'booking/setBookingPeriod',
            setArrivalPeriod: 'booking/setArrivalPeriod',
            setSelectedFilters: 'booking/setSelectedFilters',
            getBookings: 'booking/getBookings',
        }),
    }
}
</script>

<template>
    <div class="booking-filters">
        <div v-if="!loading" :key="'body'" class="booking-filters__body">
            <div class="booking-filters__element">
                <dropdown-menu
                    :label="$t('bookingFilters.brand.label')"
                    :value="selected.brand"
                    :items="brands"
                    :enable-deselect="true"
                    :undefined-value="$t('bookingFilters.brand.all')"
                    @input="setSelectedFilters({brand: $event})"/>
            </div>
            <div class="booking-filters__element">
                <dropdown-menu
                    :label="$t('bookingFilters.domain.label')"
                    :value="selected.domain"
                    :items="domains[selected.brand] || allDomains"
                    :enable-deselect="true"
                    :undefined-value="$t('bookingFilters.domain.all')"
                    @input="setSelectedFilters({domain: $event})"/>
            </div>
            <div class="booking-filters__element">
                <dropdown-menu
                    :label="$t('bookingFilters.site.label')"
                    :value="selected.site"
                    :items="siteNames"
                    :enable-deselect="true"
                    :undefined-value="$t('bookingFilters.site.all')"
                    @input="setSelectedFilters({site: $event})"/>
            </div>
            <div class="booking-filters__element">
                <dropdown-menu
                    :label="$t('bookingFilters.accommodation.label')"
                    :value="selected.accommodation"
                    :items="sites[selected.site] || allAccommodations"
                    :enable-deselect="true"
                    :undefined-value="$t('bookingFilters.accommodation.all')"
                    @input="setSelectedFilters({accommodation: $event})"/>
            </div>
            <div class="booking-filters__element">
                <dropdown-menu
                    :label="$t('bookingFilters.country.label')"
                    :value="selected.country"
                    :items="countries"
                    :enable-deselect="true"
                    :undefined-value="$t('bookingFilters.country.all')"
                    @input="setSelectedFilters({country: $event})"/>
            </div>
            <div class="booking-filters__element">
                <dropdown-menu
                    :label="$t('bookingFilters.status.label')"
                    :value="selected.status"
                    :items="status"
                    :enable-deselect="true"
                    :undefined-value="$t('bookingFilters.status.all')"
                    :translation-prefix="'bookingFilters.status.types'"
                    @input="setSelectedFilters({status: $event})"/>
            </div>
            <div class="booking-filters__element">
                <date-picker v-model="bookingPeriod"
                             :label="$t('bookingFilters.bookingPeriod.label')"
                             :heading="$t('bookingFilters.bookingPeriod.datepicker.heading')"/>
            </div>
            <div class="booking-filters__element">
                <date-picker v-model="arrivalPeriod"
                             :label="$t('bookingFilters.arrivalPeriod.label')"
                             :heading="$t('bookingFilters.arrivalPeriod.datepicker.heading')"/>
            </div>
        </div>
        <fake v-if="loading"
              :body-rows="2"
              :body-cells="5"
              :key="'fake'"/>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/BookingFilters/BookingFilters.vue